import $ from 'jquery';

import { ARROW_DOWN_KEYCODE, ARROW_UP_KEYCODE, ESC_KEYCODE } from './constants.es6';
import { addClass, removeClass, toggleAttribute, toggleClass } from './domHelpers.es6';
import Ga from './ga';
import MAEvent from './ma-event';
import Wa from './wa';

const settings = {
    stickyClass: 'sticky',
    openedSectionClass: 'content-sections__heading--opened',
    headingSelector: '.content-sections__heading',
};

export function enablePageScroll() {
    const w = $('[data-page-wrapper]');
    w.removeClass('popin-opened');
    w.css({
        top: 0,
    });
    $(window).scrollTop(w.data('scrollOrigin'));
}

export function disablePageScroll() {
    const w = $('[data-page-wrapper]');

    const scrollOrigin = $(window).scrollTop();

    w.css({
        top: -1 * scrollOrigin,
    });
    w.data('scrollOrigin', scrollOrigin);
    w.addClass('popin-opened');
}

/**
 * Toggle popup menu
 * @param {object} object DOM nodes for navMenuButton and navMenuPopup
 * @param {Element} object.navMenuButton navMenuButton element
 * @param {Element} object.navMenuPopup navMenuPopup element
 * @param {boolean} force Force of toggle
 */
function togglePopupMenu(navMenuButton, force) {
    const wasHidden = !navMenuButton.hasAttribute('aria-expanded');
    const navMenuContainer = navMenuButton.parentElement;
    const navMenuPopup = navMenuContainer.querySelector('[data-nav-menu-popup]');
    const navMenuArrow = navMenuContainer.querySelector('[data-nav-menu-popup-arrow]');

    toggleClass(navMenuButton, 'topnav-submenu__button--opened', force);
    toggleClass(navMenuPopup, 'topnav-submenu__items--visible', force);
    toggleClass(navMenuArrow, 'topnav-submenu__arrow--visible', force);
    toggleAttribute(navMenuButton, 'aria-expanded', force);

    if (
        wasHidden &&
        navMenuButton.hasAttribute('aria-expanded') &&
        navMenuButton.hasAttribute('data-ua-event-action')
    ) {
        Ga.sendForElement(navMenuButton);
    }
}

/**
 * Initialize the global nav
 */
function initializeMobileNav() {
    const mobileNavToggler = document.querySelector('[data-mobile-nav-toggler]');
    const navMenu = document.querySelector('[data-nav-menu]');
    const $navMenu = $(navMenu);
    const navMenuButtonSelector = '[data-nav-menu-button]';
    const navMenuPopupSelector = '[data-nav-menu-popup]';

    if ($(mobileNavToggler).is(':visible')) {
        $('[data-nav-account-menu]').remove();
        mobileNavToggler.addEventListener('click', () => {
            toggleClass(mobileNavToggler, 'mobile-nav-toggler--active');

            if (navMenu.hasAttribute('aria-expanded')) {
                removeClass(navMenu, 'topnav__menu--sliding');

                window.setTimeout(() => {
                    removeClass(navMenu, 'topnav__menu--visible');
                    removeClass(document.body, 'topnav-opened');
                    navMenu.removeAttribute('aria-expanded');
                }, 200);
            } else {
                addClass(document.body, 'topnav-opened');
                addClass(navMenu, 'topnav__menu--visible');

                window.setTimeout(() => {
                    addClass(navMenu, 'topnav__menu--sliding');
                    navMenu.setAttribute('aria-expanded', 'true');
                }, 0);
                Ga.sendForElement(mobileNavToggler);
            }

            mobileNavToggler.blur();
        });

        $navMenu.on('click', navMenuButtonSelector, function expandSubMenu() {
            const navMenuButton = this;
            const navMenuContainer = navMenuButton.parentElement;
            const navMenuPopup = navMenuContainer.querySelector(navMenuPopupSelector);

            toggleClass(navMenuContainer, 'topnav-submenu--opened');
            toggleClass(navMenuButton, 'topnav-submenu__button--opened');
            toggleClass(navMenuPopup, 'topnav-submenu__items--visible');
            toggleAttribute(navMenuButton, 'aria-expanded');

            $(navMenuButton)
                .parent()
                .siblings()
                .toggleClass('topnav-submenu--hidden');

            navMenuButton.blur();

            if (
                navMenuButton.hasAttribute('aria-expanded') &&
                navMenuButton.hasAttribute('data-ua-event-action')
            ) {
                Ga.sendForElement(navMenuButton);
            }
        });
    } else {
        const POPUP_RETAIN_TIMEOUT = 300;
        const hidePopupTimeouts = {};
        const hidePopupCallbacks = {};

        $('[data-nav-account-menu-mobile]').remove();
        // to open and closes popup menus on mouse hover
        $navMenu.on('mouseover', navMenuButtonSelector, function showSubMenu() {
            const navMenuButton = this;
            const navMenuButtonAriaControls = navMenuButton.getAttribute('aria-controls');

            if (hidePopupTimeouts[navMenuButtonAriaControls]) {
                clearTimeout(hidePopupTimeouts[navMenuButtonAriaControls]);
            }

            Object.entries(hidePopupCallbacks)
                .filter(([ariaControl]) => navMenuButtonAriaControls !== ariaControl)
                .forEach(([, hidePopup]) => hidePopup());

            togglePopupMenu(navMenuButton, true);
        });

        $navMenu.on('mouseleave', navMenuButtonSelector, function hideSubMenu() {
            const navMenuButton = this;
            const navMenuButtonAriaControls = navMenuButton.getAttribute('aria-controls');

            hidePopupCallbacks[navMenuButtonAriaControls] = () => {
                togglePopupMenu(navMenuButton, false);
            };

            hidePopupTimeouts[navMenuButtonAriaControls] = setTimeout(
                hidePopupCallbacks[navMenuButtonAriaControls],
                POPUP_RETAIN_TIMEOUT,
            );
        });

        $navMenu.on('mouseover', navMenuPopupSelector, function hideSubMenu() {
            const navMenuPopup = this;
            const navMenuPopupId = navMenuPopup.getAttribute('id');

            if (hidePopupTimeouts[navMenuPopupId]) {
                clearTimeout(hidePopupTimeouts[navMenuPopupId]);
            }
        });

        $navMenu.on('mouseleave', navMenuPopupSelector, function hideSubMenu(e) {
            const navMenuPopup = this;
            const navMenuContainer = navMenuPopup.parentElement;
            const navMenuButton = navMenuContainer.querySelector('[data-nav-menu-button]');

            if (e.toElement !== navMenuButton) {
                togglePopupMenu(navMenuButton, false);
            }
        });

        $navMenu.on('click', navMenuButtonSelector, function toggleSubMenu() {
            const navMenuButton = this;

            togglePopupMenu(navMenuButton);
        });

        // keyboard accessibility: open popup menu with arrow keys
        $navMenu.on('keydown', navMenuButtonSelector, function toggleSubMenu(e) {
            const navMenuButton = this;
            const navMenuContainer = navMenuButton.parentElement;
            const navMenuPopup = navMenuContainer.querySelector('[data-nav-menu-popup]');

            // open popup menu and focus on first link when user presses down arrow key
            if (e.keyCode === ARROW_DOWN_KEYCODE) {
                e.preventDefault();
                const navMenuFirstChild = navMenuPopup.querySelector('li[role="presentation"] a'); // The first element is only for mobile

                togglePopupMenu(navMenuButton, true);

                if (navMenuFirstChild) {
                    navMenuFirstChild.focus();
                }
            }

            // open popup menu and focus on last link when user presses up arrow key
            if (e.keyCode === ARROW_UP_KEYCODE) {
                e.preventDefault();
                const navMenuLastChild = navMenuPopup.querySelector('li:last-child a');

                togglePopupMenu(navMenuButton, true);

                if (navMenuLastChild) {
                    navMenuLastChild.focus();
                }
            }
        });

        $navMenu.on('keydown', '[data-nav-menu-popup] li a', function toggleSubMenu(e) {
            const navMenuListItem = this.parentElement;
            const nextNavMenuListItem = navMenuListItem.nextElementSibling;
            const previousNavMenuListItem = navMenuListItem.previousElementSibling;

            // add ability to navigate between nav menu links with down arrow key
            if (e.keyCode === ARROW_DOWN_KEYCODE && nextNavMenuListItem) {
                e.preventDefault();
                e.stopPropagation();

                const nextNavMenuLink = nextNavMenuListItem.querySelector('a');

                if (nextNavMenuLink) {
                    nextNavMenuLink.focus();
                }
            }

            // if there is no next link, focus back to the first link of the popup menu
            if (e.keyCode === ARROW_DOWN_KEYCODE && !nextNavMenuListItem) {
                e.preventDefault();

                const firstSubMenuLink = $(navMenuListItem)
                    .parent()
                    .find('li[role="presentation"] a')[0];

                if (firstSubMenuLink) {
                    firstSubMenuLink.focus();
                }
            }

            // add ability to navigate between nav menu links with up arrow key
            if (
                e.keyCode === ARROW_UP_KEYCODE &&
                previousNavMenuListItem.getAttribute('role') === 'presentation'
            ) {
                e.preventDefault();
                e.stopPropagation();

                const previousNavMenuLink = previousNavMenuListItem.querySelector('a');

                if (previousNavMenuLink) {
                    previousNavMenuLink.focus();
                }
            }

            // if there is no previous link, focus back to the last link of the popup menu
            if (e.keyCode === ARROW_UP_KEYCODE && !previousNavMenuListItem.getAttribute('role')) {
                e.preventDefault();
                e.stopPropagation();

                const lastSubMenuLink = $(navMenuListItem)
                    .parent()
                    .find('li[role="presentation"]:last-of-type a')[0];

                if (lastSubMenuLink) {
                    lastSubMenuLink.focus();
                }
            }

            // close the navMenuPopup with escape key
            if (e.keyCode === ESC_KEYCODE) {
                const navMenuButton = this.closest('.topnav-submenu').querySelector(
                    '[data-nav-menu-button]',
                );
                togglePopupMenu(navMenuButton, false);
                navMenuButton.focus();
            }
        });

        // closes all popup menus when user focuses on nav button or top nav link
        $navMenu.on('focus', `${navMenuButtonSelector}, [data-nav-top-level-link]`, () => {
            $navMenu.find(`${navMenuButtonSelector},[aria-expanded]`).each(function hideSubMenu() {
                togglePopupMenu(this, false);
            });
        });
    }
}

/**
 * Open the section depending of a heading
 * @param {jQuery} $heading Object defining heading element
 * @param {boolean} noScroll Scroll to heading if true
 */
function _openSection($heading, noScroll) {
    // Show the section
    const $section = $heading.next();
    $section.show();
    $heading.addClass(settings.openedSectionClass);
    if (!noScroll) {
        $('html, body')
            .stop()
            .animate({ scrollTop: $heading.offset().top }, '500', 'swing');
    }
    $section.trigger({
        type: MAEvent.navigationSectionOpened,
        time: new Date(),
    });
}

/**
 * Close the section depending of a heading
 * @param {jQuery} $heading Object defining heading element
 */
function _closeSection($heading) {
    // Hide the section
    const $section = $heading.next();
    $section.hide();
    $heading.removeClass(settings.openedSectionClass);
    $section.trigger({
        type: MAEvent.navigationSectionClosed,
        time: new Date(),
    });
}

/**
 * Initialize the content section display and behaviors (on price pages)
 */
function initializeSections() {
    const $container = $('[data-prices-content-sections]');

    const $sectionHeadings = $container.children(settings.headingSelector);

    $sectionHeadings.each(function sectionHeadingsEach() {
        const $sectionHeading = $(this);
        $sectionHeading.html($sectionHeading.data('short-title'));
        // Hide section content
        $sectionHeading.next().hide();
        // Attach click event to open section
        $sectionHeading.on('click', e => {
            e.preventDefault();
            if ($sectionHeading.hasClass(settings.openedSectionClass)) {
                _closeSection($sectionHeading);
            } else {
                _openSection($sectionHeading);
            }
        });

        $sectionHeading
            .show()
            .append('<div class="content-sections__show icon icon-arrow-down"></div>');
    });

    _openSection($sectionHeadings.first(), true);
}

/**
 *
 * @param {jQueryElement} $wrapper Wrapper of the navigation tabs
 * @param {Function} callback Do something after tab changed
 * @param {Function(activeTab: String)} callback - Do something after tab changed
 * ```
 * activeTab - ID of tab became active
 * ```
 * @callback
 */
function handleTabsNav($wrapper, callback, activeClassname = 'nav-tabs__item--active') {
    $wrapper.on('click', 'a, button', function onTabClick(event) {
        event.preventDefault();
        const $this = $(this);
        const targetLink = $this.attr('href');
        $wrapper.find(`.${activeClassname}`).removeClass(activeClassname);
        $this.addClass(activeClassname);
        // Show Panel
        $(targetLink)
            .removeClass('hide')
            .siblings()
            .addClass('hide');
        Wa.setDisplayTracking($(targetLink));

        if (typeof callback === 'function') {
            callback(targetLink);
        }
    });
}

/**
 *
 * @param {Element} domNode
 * @param {Function} callback
 * @param {String} activeClassname
 * ```
 * activeTab - ID of tab became active
 * ```
 * @callback
 * TODO: refactoriser les appel handleTabsNav avec cette fonction ci. exit Jquery TECH-1223
 */
function handleTabsNavNative(domNode, callback, activeClassname = 'nav-tabs__item--active') {
    if (!domNode) {
        return;
    }
    function activeTab(target) {
        const panel = domNode.parentElement.querySelector(target.getAttribute('href'));
        const domNodeChildActive = domNode.querySelector(`.${activeClassname}`);
        removeClass(domNodeChildActive, activeClassname);
        addClass(target, activeClassname);
        for (let j = 0; j < panel.parentElement.children.length; j++) {
            addClass(panel.parentElement.children[j], 'hide');
        }
        removeClass(panel, 'hide');
        if (typeof callback === 'function') {
            callback(panel);
        }
    }

    const domChild = domNode.querySelectorAll('a');
    for (let i = 0; i < domChild.length; i++) {
        domChild[i].addEventListener('click', event => {
            event.preventDefault();
            activeTab(event.target);
        });
    }
}

export default {
    enablePageScroll,
    disablePageScroll,
    initializeMobileNav,
    initializeSections,
    handleTabsNav,
    handleTabsNavNative,
};
